// TechnologyPage.js
import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Header from '../components/Header';
import ContactFooter from '../components/ContactFooter';
import BlogPage, { blogPosts } from './BlogPage';
import styles from './TechnologyPage.module.css';

// Use blog posts from BlogPage for consistency

export default function TechnologyPage() {
  const pageSubtitle = "Technical Research & Innovation | Bridging Theory and Implementation";
  const bannerImageUrl = "/images/BannerPage1.jpg";

  const featuredPosts = blogPosts.filter(post => post.featured);
  const regularPosts = blogPosts.filter(post => !post.featured);

  return (
    <div className={styles.pageContainer}>
      <Routes>
        <Route path="/" element={
          <div>
            <Header backgroundImageUrl={bannerImageUrl} subtitle={pageSubtitle} />
            
            <main className={styles.mainContent}>
              {/* Introduction Section */}
              <section className={styles.introSection}>
                <div className={styles.introContent}>
                  <h1 className={styles.pageTitle}>Research & Technical Insights</h1>
                  <p className={styles.pageDescription}>
                    Exploring science, technology, and artificial intelligence, from theoretical foundations 
                    to practical implementations. Each article provides in-depth analysis, mathematical 
                    derivations, and real-world applications of cutting-edge technologies.
                  </p>
                </div>
              </section>

              {/* Featured Posts */}
              <section className={styles.featuredSection}>
                <h2 className={styles.sectionTitle}>Featured Research</h2>
                <div className={styles.featuredGrid}>
                  {featuredPosts.map(post => (
                    <Link key={post.path} to={post.path} className={styles.featuredCard}>
                      <div 
                        className={styles.featuredCardBackground}
                        style={{ backgroundImage: post.backgroundImage }}
                      >
                        <div className={styles.featuredCardOverlay}>
                          <div className={styles.featuredCardContent}>
                            <span className={styles.postCategory}>{post.category}</span>
                            <h3 className={styles.featuredCardTitle}>{post.title}</h3>
                            <p className={styles.featuredCardDescription}>{post.description}</p>
                            <div className={styles.readMoreIndicator}>
                              <span>Read Article</span>
                              <span className={styles.arrow}>→</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>

              {/* All Articles */}
              <section className={styles.allArticlesSection}>
                <h2 className={styles.sectionTitle}>All Articles</h2>
                <div className={styles.articlesGrid}>
                  {blogPosts.map(post => (
                    <Link key={post.path} to={post.path} className={styles.articleCard}>
                      <div 
                        className={styles.articleCardImage}
                        style={{ backgroundImage: post.backgroundImage }}
                      >
                        <div className={styles.articleCardOverlay}>
                          <span className={styles.postCategory}>{post.category}</span>
                        </div>
                      </div>
                      <div className={styles.articleCardContent}>
                        <h3 className={styles.articleCardTitle}>{post.title}</h3>
                        <p className={styles.articleCardDescription}>{post.description}</p>
                        <div className={styles.articleCardFooter}>
                          <span className={styles.readMore}>Read More →</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>
            </main>

            <ContactFooter 
              title="Research Collaboration"
              description="Interested in discussing these topics or collaborating on research? Let's explore the possibilities together."
              copyrightText="© 2025 Entrosystem. All rights reserved."
              backgroundImageUrl={bannerImageUrl}
            />
          </div>
        } />

        {/* Individual Article Routes - Now handled by BlogPage component */}
        {blogPosts.map(post => (
          <Route 
            key={post.path} 
            path={`/${post.path}`} 
            element={<BlogPage />}
          />
        ))}
      </Routes>
    </div>
  );
}